(function () {
var $128d598e9f4c4a7f$var$hero = {
    gradientMap: {
        green: 'linear-gradient(90deg, rgb(13, 177, 188) 0%, rgb(176, 210, 53) 100%)',
        blue: 'linear-gradient(90deg, #07428A 0%, #00AEEF 100%)',
        purple: 'linear-gradient(90deg, rgb(112, 56, 137) 0%, rgb(103, 139, 199) 100%)',
        disabled: 'none'
    },
    init: function() {
        this.initializeHeroSliders();
    },
    initializeHeroSliders: function() {
        var _this = this;
        var heroSliders = document.querySelectorAll('[data-hero-slider]');
        if (!heroSliders.length) return;
        heroSliders.forEach(function(slider) {
            return _this.setupSlider(slider);
        });
    },
    setupSlider: function(slider) {
        var _this = this;
        var slides = slider.querySelectorAll('.swiper-slide');
        var _this_getSliderElements = this.getSliderElements(slider), gradientEl = _this_getSliderElements.gradientEl, colorEl = _this_getSliderElements.colorEl, paginationEl = _this_getSliderElements.paginationEl;
        if (slides.length < 2) {
            this.updateStyles(slider, slides, gradientEl, colorEl, 0);
            return;
        }
        var swiper = new Swiper(slider, {
            loop: true,
            slidesPerView: 1,
            autoplay: {
                delay: 5000
            },
            pagination: {
                el: paginationEl,
                clickable: true
            },
            on: {
                init: function() {
                    return _this.updateStyles(swiper, slides, gradientEl, colorEl, 0);
                },
                slideChangeTransitionStart: function(swiper) {
                    return _this.updateStyles(swiper, slides, gradientEl, colorEl, swiper.realIndex);
                }
            }
        });
    },
    getSliderElements: function(slider) {
        var heroContainer = slider.closest('.hero');
        return {
            gradientEl: heroContainer.querySelector('[data-hero-gradient]'),
            colorEl: heroContainer.querySelector('[data-hero-color]'),
            paginationEl: heroContainer.querySelector('[data-hero-pagination]')
        };
    },
    updateStyles: function(swiper, slides, gradientEl, colorEl, index) {
        var currentSlide = slides[index];
        var color = currentSlide.querySelector('[data-color]').dataset.color;
        var gradient = currentSlide.querySelector('[data-gradient]').dataset.gradient;
        gradientEl.style.background = this.gradientMap[gradient] || this.gradientMap['disabled'];
        colorEl.style.background = color;
    }
};
var $128d598e9f4c4a7f$export$2e2bcd8739ae039 = $128d598e9f4c4a7f$var$hero;
$128d598e9f4c4a7f$var$hero.init();

})();
//# sourceMappingURL=scripts.js.map
